var _excluded = ["title", "links", "additionalLink", "asideLinks"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { memo, useContext, useEffect, useState } from "react";
import IsDarkModeContext from "../../../../../../../../contexts/IsDarkModeContext";
import useBreakpoint from "../../../../../../../../hooks/useBreakpoint";
import { useFocusWrapper } from "../../../../../../../../hooks/useFocusWrapper";
import replaceSpaceToDashAndLowerCase from "../../../../../../../../utils/replaceSpaceToDashAndLowerCase";
import TextAtm from "../../../../../../../atoms/TextAtm";
import UnderlineLinkAtm from "../../../../../../../atoms/UnderlineLinkAtm";
import PushOrg from "../../../../../../PushOrg";
import { StateContext } from "../../../../../contexts";
import DispatchContext from "../../../../../contexts/DispatchContext";
import { ActionType } from "../../../../../reducers/mainReducer";
import DropdownLinksOrg from "../../../../common/DropdownLinksOrg";
import DropdownOrg from "../../../../common/DropdownOrg";
import { hugeBreakpointValue } from "../../../../settings";
import PointerLinkMol from "./PointerLinkMol";
function NavigationDropdownContentOrg(_ref) {
  var title = _ref.title,
    links = _ref.links,
    additionalLink = _ref.additionalLink,
    asideLinks = _ref.asideLinks,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(StateContext),
    navigationIndex = _useContext.navigationIndex;
  var dispatch = useContext(DispatchContext);
  var _useFocusWrapper = useFocusWrapper(),
    isWrapperFocused = _useFocusWrapper.isWrapperFocused,
    focusWrapperRef = _useFocusWrapper.focusWrapperRef,
    handleOnFocusWrapper = _useFocusWrapper.handleOnFocusWrapper,
    handleOnBlurWrapper = _useFocusWrapper.handleOnBlurWrapper;
  var isDarkMode = useContext(IsDarkModeContext);
  var isHugeScreen = useBreakpoint(hugeBreakpointValue);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeLinkIndex = _useState2[0],
    setActiveLinkIndex = _useState2[1];
  var isInactiveLink = function isInactiveLink(index) {
    return activeLinkIndex !== null && activeLinkIndex !== index;
  };
  var handleLinkClick = function handleLinkClick(onClick) {
    return function (event) {
      dispatch({
        type: ActionType.SET_NAVIGATION_INACTIVE
      });
      if (onClick) {
        onClick(event);
      }
    };
  };
  var handleLinkMouseEnter = function handleLinkMouseEnter(index) {
    return function () {
      return setActiveLinkIndex(index);
    };
  };
  var handleLinkMouseLeave = function handleLinkMouseLeave() {
    return setActiveLinkIndex(null);
  };
  useEffect(function () {
    if (navigationIndex !== null && !isWrapperFocused) {
      if (!isHugeScreen) {
        dispatch({
          type: ActionType.SET_NAVIGATION_ACTIVE,
          navigationIndex: null,
          markerLeftPosition: null,
          desktopDropdown: null
        });
      }
      dispatch({
        type: ActionType.SET_NAVIGATION_LIST_FOCUS,
        navigationListFocusIndex: navigationIndex + 1,
        isHugeScreen: isHugeScreen
      });
    }
  }, [isWrapperFocused]);
  return /*#__PURE__*/React.createElement("div", {
    ref: focusWrapperRef,
    onFocus: handleOnFocusWrapper,
    onBlur: handleOnBlurWrapper
  }, /*#__PURE__*/React.createElement(DropdownOrg, _extends({
    main: /*#__PURE__*/React.createElement(React.Fragment, null, !isHugeScreen && /*#__PURE__*/React.createElement(PushOrg, {
      bottomSpace: 3.5
    }, /*#__PURE__*/React.createElement(TextAtm, {
      typography: "small4_u"
    }, title)), /*#__PURE__*/React.createElement(DropdownLinksOrg, {
      links: links.map(function (link, linkIndex) {
        return /*#__PURE__*/React.createElement(PointerLinkMol, {
          key: link.title,
          title: link.title,
          subtitle: link.subtitle,
          label: link.label,
          to: link.to,
          href: link.href,
          linkTitle: link.linkTitle,
          onClick: handleLinkClick(link.onClick),
          onMouseEnter: handleLinkMouseEnter(linkIndex),
          onMouseLeave: handleLinkMouseLeave,
          isInactive: isInactiveLink(linkIndex),
          "data-test-id": "menu-".concat(replaceSpaceToDashAndLowerCase(title), "-").concat(replaceSpaceToDashAndLowerCase(link.title)),
          hasCover: true
        });
      }),
      additionalLink: additionalLink ? /*#__PURE__*/React.createElement(UnderlineLinkAtm, {
        key: additionalLink.title,
        to: additionalLink.to,
        href: additionalLink.href,
        title: additionalLink.title,
        typography: "small2",
        color: isDarkMode ? "white" : "secondary",
        onClick: handleLinkClick(additionalLink.onClick),
        hasCover: true,
        "data-test-id": "menu-".concat(replaceSpaceToDashAndLowerCase(title), "-").concat(replaceSpaceToDashAndLowerCase(additionalLink.title))
      }, additionalLink.text) : null
    })),
    aside: asideLinks ? /*#__PURE__*/React.createElement(DropdownLinksOrg, {
      links: asideLinks.map(function (asideLink) {
        return /*#__PURE__*/React.createElement(PointerLinkMol, {
          key: asideLink.title,
          title: asideLink.title,
          subtitle: asideLink.subtitle,
          to: asideLink.to,
          href: asideLink.href,
          linkTitle: asideLink.linkTitle,
          onClick: handleLinkClick(asideLink.onClick),
          "data-test-id": "menu-".concat(replaceSpaceToDashAndLowerCase(title), "-").concat(replaceSpaceToDashAndLowerCase(asideLink.title)),
          isAside: true,
          hasCover: true
        });
      })
    }) : null
  }, restProps)));
}
export default /*#__PURE__*/memo(NavigationDropdownContentOrg);